import React from "react";
import { GripVertical, X, Plus } from "lucide-react";
import { useEditMode } from "../lib/EditModeContext";

/**
 * Small × delete button + drag handle affordance shown next to every editable row
 * when EDIT MODE is on (drag) or on hover (delete).
 */
export const RowActions = ({ onDelete, testid, showDrag = true, handleProps, className = "" }) => {
  const { editMode } = useEditMode();
  return (
    <div className={`op-row-actions ${editMode ? "op-row-actions--armed" : ""} ${className}`}>
      {showDrag && editMode && (
        <span
          {...(handleProps || {})}
          className="op-row-handle"
          data-testid={testid ? `${testid}-drag` : undefined}
          aria-label="Drag to reorder"
          title="Drag to reorder"
        >
          <GripVertical size={12} strokeWidth={1.6} />
        </span>
      )}
      {onDelete && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onDelete(); }}
          className="op-row-delete"
          data-testid={testid ? `${testid}-delete` : undefined}
          aria-label="Delete row"
          title="Delete row"
        >
          <X size={12} strokeWidth={2} />
        </button>
      )}
    </div>
  );
};

/**
 * Inline "+ ADD ROW" button used at the bottom of every editable list section.
 * Only renders when EDIT MODE is on — keeps the interface calm by default.
 */
export const AddRowButton = ({ onClick, label = "ADD ROW", testid }) => {
  const { editMode } = useEditMode();
  if (!editMode) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="op-add-row"
    >
      <Plus size={11} strokeWidth={1.8} />
      <span>+ {label}</span>
    </button>
  );
};

export default RowActions;
